import React, { FC } from "react";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles({
  message: {
    fontSize: "0.7rem",
  },
});

interface DisclaimerProps {
  message: string;
}

const Disclaimer: FC<DisclaimerProps> = ({ message }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.message} variant="body2">
      {message}
    </Typography>
  );
};

export default Disclaimer;
